import { render, staticRenderFns } from "./CompanyPost.vue?vue&type=template&id=ce229dae"
import script from "./CompanyPost.vue?vue&type=script&lang=js"
export * from "./CompanyPost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports